
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { FormData } from '@/hooks/useFormState';
import { ArrowRight } from 'lucide-react';

interface PersonalInfoProps {
  formData: FormData;
  updateFormData: (field: keyof FormData, value: any) => void;
  onNext: () => void;
  isValid: boolean;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({
  formData,
  updateFormData,
  onNext,
  isValid
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isValid) {
      onNext();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5 animate-fade-in">
      <div className="space-y-1 sm:space-y-2 text-center">
        <h2 className="text-xl sm:text-2xl font-semibold tracking-tight">Personal Information</h2>
        <p className="text-sm sm:text-base text-muted-foreground">Please provide your contact details below</p>
      </div>

      <div className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="name">Full Name</Label>
          <Input
            id="name"
            type="text"
            placeholder="Enter your full name"
            value={formData.name}
            onChange={(e) => updateFormData('name', e.target.value)}
            required
            className="transition-all duration-200 focus:ring-2 focus:ring-primary/20 bg-white"
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="email">Email Address</Label>
          <Input
            id="email"
            type="email"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={(e) => updateFormData('email', e.target.value)}
            required
            className="transition-all duration-200 focus:ring-2 focus:ring-primary/20 bg-white"
          />
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="telephone">Telephone Number</Label>
          <Input
            id="telephone"
            type="tel"
            placeholder="Enter your telephone number"
            value={formData.telephone}
            onChange={(e) => updateFormData('telephone', e.target.value)}
            required
            className="transition-all duration-200 focus:ring-2 focus:ring-primary/20 bg-white"
          />
        </div>
      </div>

      <Button 
        type="submit" 
        className="w-full group"
        disabled={!isValid}
      >
        Continue 
        <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
      </Button>
    </form>
  );
};

export default PersonalInfo;
